export default __webpack_public_path__ + "static/media/4.1a47f103.jpg";